import { LOGIN_USER, LOGOUT_USER } from "../actions/userActions";

const initialState = {
    user: null,
    isLoggedIn: false,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_USER:
            return { ...state, user: action.payload, isLoggedIn: true };
        case LOGOUT_USER:
            return { ...state, user: null, isLoggedIn: false };
        default:
            return state;
    }
};

export default userReducer;